import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { contractLineService } from 'shared/services';
import { ContractLine } from '../../../contracts/types';
import { IProductWarehouseContract } from '../../../products/types';

interface UnapprovedFormProps {
  pwc: IProductWarehouseContract;
  identificators: number[];
  onSubmit: any;
}

function EditUnapprovedMovement({ pwc, onSubmit }: UnapprovedFormProps) {
  const { t } = useTranslation();

  const [contractLines, setContractLines] = useState<ContractLine[]>([]);

  useEffect(() => {
    const params = {
      product: pwc.product,
      product__exact: true,
      warehouses__contains: pwc.warehouse,
      warehouse__isnull: false
    };
    contractLineService.getAllBaseInformation(params).then((res) => {
      setContractLines(
        res.map((contractLine) => {
          return {
            id: contractLine.id,
            code: `${contractLine['code']}`,
            description: `${contractLine['code']} - ${contractLine.warehouse?.code}`
          };
        })
      );
    });
  }, []);

  return (
    <EnhancedForm onSubmit={onSubmit} formId="updateMovement" hideControls>
      <IdentityField
        name="contract"
        label={t('global.contract')}
        component={AutocompleteAdapter}
        options={contractLines}
        type="text"
        optionValue="id"
        optionLabel="description"
        defaultValue={pwc.contract}
        validate={required}
      />
    </EnhancedForm>
  );
}

export default EditUnapprovedMovement;
